// The custom fields a custom action sends: its own, plus any a form prepared for this run
// (cc-custom-action-button's prepareCustomAction - e.g. the inquiry offer's quantity tiers).
// With nothing prepared the action's own list is returned as it is, so the request is exactly
// what it was before.
export function withPreparedCustomFields(actionFields, preparedFields) {
  return preparedFields && preparedFields.length
    ? [...(actionFields || []), ...preparedFields]
    : actionFields
}
